import React from "react";
import * as PropTypes from "prop-types";

const UIInfoBanner = ({icon, title, description}) => {
	if( !title && !description )
	{
		return null;
	}

	return (
		<div className="info-banner">
			{icon && <div className="info-banner-icon">{icon}</div>}
			<div>
				{title && <p className="info-banner-title">{title}</p>}
				{description && <p className="info-banner-description">{description}</p>}
			</div>
		</div>
	);
};

UIInfoBanner.propTypes = {
	icon       : PropTypes.node,
	title      : PropTypes.string,
	description: PropTypes.node,
};

UIInfoBanner.defaultProps = {
	icon       : null,
	title      : "",
	description: "",
};

export default UIInfoBanner;
